export async function fetchWithTimeout (url: string, options: any, timeout = 2000) {
  return Promise.race([
    fetch(url, options),
    // eslint-disable-next-line promise/param-names
    new Promise<Response>((_, reject) =>
      setTimeout(() => reject(new Error('timeout')), timeout)
    )
  ]);
}
